import { atom } from "recoil";

export const hardReset = atom({
  key: "hardReset",
  default: false,
});
